/* eslint-disable import/no-dynamic-require */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  makeStyles,
  Theme,
  createStyles,
  MenuItem,
  TextField,
  Grid,
  Tooltip
} from "@material-ui/core";
import { ThemeProvider, createTheme as createMuiTheme } from "@material-ui/core/styles";
import { grey, red } from "@material-ui/core/colors";

import { ViewModeTextField } from "../input/text-fields/ViewModeTextField";
import { IconTooltip } from "../icons/IconTooltip";

export const useDropdownStyles = makeStyles((theme: Theme) => ({
  wh_16: {
    width: "16px !important",
    height: "16px !important"
  },
  c_pointer: {
    cursor: "pointer",
    position: "absolute",
    right: "12px",
    pointerEvents: "none"
  },

  root: {
    "&.MuiMenuItem-root": {
      fontWeight: "normal"
    },
    "&.MuiListItem-root.Mui-selected": {
      fontWeight: 600,
      backgroundColor: "#fff !important"
    },
    "&.MuiSelect-select:": {
      "&:focus": {
        marginBottom: "0px !important",
        paddingTop: 12,
        paddingBottom: 11
      }
    },
    "&.MuiListItem-button": {
      "&:hover": {
        fontWeight: 600,
        backgroundColor: "#f6f9fc !important"
      }
    }
  }
}));

const MuiTheme = createMuiTheme({
  palette: {
    primary: grey,
    secondary: {
      light: "#32325d",
      main: "#5566d6",
      dark: "#02669f",
      contrastText: "#5f72e4"
    },
    common: {
      black: "#000",
      white: "#fff"
    },
    error: red,
    text: {
      primary: "rgba(50, 50, 93, 0.5)",
      secondary: "#32325d",
      hint: "#5566d6"
    },
    background: {
      paper: "#f8f9ff",
      default: "rgba(0, 0, 0, 0.02)"
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif !important"
  },
  overrides: {
    MuiAppBar: {
      colorDefault: {
        backgroundImage: "linear-gradient(93deg, #0fcbef 4%, #1071ee 90%)",
        // backgroundImage: "linear-gradient(90deg, #014DB0 55%, #009BC9 90%)",
        padding: "12px 12px 12px 17px",
        boxShadow: "none"
      }
    },

    MuiFormControlLabel: {
      root: {
        "&.$Mui-disabled": {
          cursor: "no-drop !important"
        }
      }
    },

    MuiSelect: {
      root: {
        fontWeight: 500
      },
      select: {
        color: "#32325d",
        "&:focus": {
          borderRadius: 3,
          backgroundColor: "#f7f9fc !important",
          margin: "-3px"
        },
        "&:selected": {
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04) !important"
          }
        }
      }
    },

    MuiMenuItem: {
      root: {
        whiteSpace: "break-spaces",
        fontWeight: 500,
        "&:hover": {
          fontWeight: 600
        }
      }
    },
    MuiListItem: {
      root: {
        "&.$Mui-selected": {
          fontWeight: 600,
          backgroundColor: "#f8f9ff !important",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04) !important"
          }
        },
        "&.$Mui-focusVisible": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        }
      }
    },
    MuiInputLabel: {
      outlined: {
        letterSpacing: "normal",
        color: "#363b41"
      },
      formControl: {
        transform: "none !important"
      }
    },
    MuiInputBase: {
      root: {
        "&:focus": {
          borderRadius: "4px",
          border: "1px solid #5e72e4 !important"
        }
      },
      input: {
        padding: "10px",
        "&:focus": {
          borderRadius: "4px",
          border: "0",
          lineHeight: "22px"
          // border: "1px solid #5e72e4 !important"
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "#cad1d7",
          borderWidth: 1
        },
        "&$focused $notchedOutline": {
          borderColor: "#5e72e4",
          borderWidth: 2
        }
      }
    },
    MuiInput: {
      root: {
        borderBottom: "1px solid transparent"
      },
      underline: {
        "&&&&:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:after": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:after": {
          borderBottom: "1px solid transparent"
        }
      }
    },
    MuiTableHead: {
      root: {
        color: "#424242",
        background: "#eef6ff",
        fontSize: "12px"
      }
    },
    MuiTableCell: {
      root: {
        padding: "0px"
      },
      head: {
        color: "#424242",
        padding: "10px 0px 7px 8px",
        fontSize: "12px"
      },
      body: {
        color: "#424242",
        fontSize: "12px",
        padding: "7px 0px 8px 8px "
      }
    },
    MuiTablePagination: {
      root: {
        color: "#424242"
      }
    },
    MuiPaper: {
      root: {
        color: "#424242",
        backgroundColor: "#FFF",
        // marginTop: "50px",
        // minWidth: "365px !important",
        "@media (max-width: 1024px)": {
          // minWidth: "279px !important"
        },
        "@media (max-width: 768px)": {
          // minWidth: "307px !important"
        }
      }
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true // No more ripple, on the whole application!
    }
  }
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: "4px"
      }
    },
    input: {
      borderRadius: 4,
      position: "relative",
      border: "1px solid #cad1d7",
      fontSize: 14,
      padding: "13px 12px",
      color: "#32325d",
      alignSelf: "flex-end",
      transition: theme.transitions.create(["box-shadow"]),
      "&:focus": {
        "text-decoration-line": "none",
        // borderRadius: "4px",
        border: "solid 1px #5e72e4 !important"
      }
    },
    formControl: {
      marginTop: theme.spacing(1)
    },
    selectClassesOutlined: {
      padding: "10px 14px !important",
      fontWeight: 600
    },
    labelContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      // marginTop: "1px",
      width: "100%"
    },
    commentBox: {
      marginTop: "20px",
      "& label": {
        width: "100%",
        "& div": {
          "& input": {
            marginBottom: "20px"
            // border: "1px solid #cad1d7",
          }
        }
      }
    },
    labelShrink: {
      transform: "translate(0px, -8px) scale(1) !important"
    },
    labelRequired: {
      color: "#f75676",
      fontSize: "12px important",
      marginLeft: "4px important",
      paddingTop: 1
      // marginBottom: "4px !important"
    },
    selectLabel: {
      border: "1px solid red",
      marginBottom: "10px !important"
    },
    iconInfo: {
      width: "16px !important",
      height: "16px !important",
      color: "#32325d",
      "&:hover": {
        color: "#5e72e4"
      }
    },
    labelInformation: {
      fontSize: 12,
      fontWeight: 600,
      color: "#8897aa",
      lineHeight: "16px",
      // height: "14px",
      "&:hover": {
        color: "#5e72e4"
      },
      display: "inline-block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      maxWidth: "95%",
      textOverflow: "ellipsis",
      pointerEvents: "all"
    },
    tooltip: {
      color: "#32325d",
      backgroundColor: "white",
      fontFamily: `"Open Sans", sans-serif !important`,
      fontSize: 12,
      boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
      padding: "5px"
    },
    arrow: {
      color: "white"
    },
    iconInfoContainer: {
      height: "16px",
      textAlign: "end",
      position: "absolute",
      right: "0",
      top: "0",
      zIndex: 1
    },
    selectEmpty: {
      marginTop: 21,
      padding: 4,
      notchedOutline: {},
      color: "#323536",
      fontSize: 14,
      "&:before": {
        borderColor: "#cad1d7"
      },
      "&:after": {
        borderColor: "#cad1d7"
      }
    },
    selectEmptyNot: {
      width: "356px",
      height: "46px",
      margin: "0 30px",
      padding: "14px 14px 13px 12px",
      borderRadius: "4px",
      border: "solid 1px #cad1d7",
      backgroundColor: "#ffffff",
      "&:before": {
        borderColor: "#cad1d7"
      },
      "&:after": {
        borderColor: "#cad1d7"
      }
    },
    labelRequiredComments: {
      color: "#f75676",
      // marginLeft: "4px",
      paddingLeft: "4px",
      fontSize: "12px",
      // marginBottom: "4px",
      marginTop: "5px"
    }
  })
);

export interface DropDownProps {
  formControlTestId: string;
  style?: React.CSSProperties;
  inputLabelId: string;
  inputLabelTestId: string;
  label: string;
  selectId: string;
  selectTestId: string;
  selectionValue: string;
  selectionOnChange?: (event: React.ChangeEvent<{ value: unknown }>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  selectionData: { [key: string]: any }[];
  helperText: string;
  helperTextTestId?: string;
  valueTestId?: string;
  isViewMode?: boolean;
  isLATView?: boolean;
  infoIconData?: any;
  editedLabel?: any;
  className?: any;
  editedData?: any;
  notRequired?: boolean;
  modalLink?: any;
  enableReason?: boolean;
  fromSettelement?: boolean;
  menuItemStyles?: string;
  disabled?: boolean;
  isServicerMandatory?: boolean;
  renderCustomInfoTag?: any;
}
const getImage = (name: string): string => {
  return require(`../../images/${name}`);
};
const cookievalue = `; ${document.cookie}`;
const parts = cookievalue.split("; " + "loginFlow" + "=");
let loginflow;
if (parts.length === 2) {
  // @ts-ignore
  loginflow = parts
    .pop()
    .split(";")
    .shift();
} else {
  loginflow = null;
}
const isLATUser = loginflow === "LAT";

const arrowDown = getImage("Arrow_down.svg");
const arrowUp = getImage("Arrow_up.svg");

export function DropDown(props: DropDownProps) {
  const classes = useStyles();
  const dropdownStyles = useDropdownStyles();
  const { formControlTestId, style, inputLabelId, inputLabelTestId } = props;
  const {
    selectId,
    selectTestId,
    selectionValue,
    selectionOnChange = () => {},
    isViewMode,
    onBlur,
    modalLink
  } = props;
  const {
    selectionData,
    helperText,
    label,
    editedData,
    isLATView,
    helperTextTestId,
    infoIconData,
    valueTestId,
    editedLabel,
    notRequired,
    enableReason = false,
    fromSettelement,
    menuItemStyles,
    disabled,
    isServicerMandatory,
    renderCustomInfoTag
  } = props;
  const [isOpen, setIsOpen] = React.useState(true);
  const WrappedIcon = (_props: JSX.IntrinsicAttributes) => (
    <img
      src={isOpen ? arrowDown : arrowUp}
      alt="Expand"
      className={`${dropdownStyles.c_pointer} ${dropdownStyles.wh_16}`}
    />
  );
  const selectionMap = React.useMemo(() => {
    return new Map(selectionData.map(option => [option.value, option]));
  }, [selectionData]);

  return isViewMode ? (
    <ViewModeTextField
      label={label}
      infoIconData={infoIconData}
      value={selectionMap.get(selectionValue)?.label ?? selectionValue}
      editedLabel={editedLabel}
      editedData={editedData}
      fromSettelement={fromSettelement}
      isServicerMandatory={isServicerMandatory}
      renderCustomInfoTag={renderCustomInfoTag}
    />
  ) : (
    <div
      style={
        inputLabelId === "creditBorrowerDrop"
          ? {
              position: "relative"
            }
          : {
              width: "100%",
              position: "relative"
            }
      }
    >
      {infoIconData ? (
        <div className={classes.iconInfoContainer}>
          <IconTooltip topic="Information" infoIconData={infoIconData} />
        </div>
      ) : null}
      <FormControl
        variant="outlined"
        data-testid={formControlTestId}
        className={classes.formControl}
        disabled={disabled}
        style={{ ...style, flex: 1, width: "100%" }}
      >
        <InputLabel
          error={!!helperText}
          shrink
          id={inputLabelId}
          data-testid={inputLabelTestId}
          classes={{
            shrink: classes.labelShrink
          }}
          style={{
            fontSize: 12,
            color: "#8897aa",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%"
            // transform: "translate(0px, -9px) scale(1)"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "space-between",
              position: "relative"
            }}
          >
            {/* <div */}
            {/* style={{
                display: "flex",
                whiteSpace: "normal"
              }}
            > */}
            <Tooltip
              title={`${label}`}
              placement="right"
              arrow
              classes={{
                tooltip: classes.tooltip,
                arrow: classes.arrow
              }}
            >
              <span className={classes.labelInformation}>{label}</span>
            </Tooltip>
            {!notRequired && (
              <span
                className={classes.labelRequired}
                style={{ marginLeft: "4px", paddingTop: "1px" }}
              >
                <sup>*</sup>
              </span>
            )}
          </div>
          {modalLink !== "" ? <div>{modalLink}</div> : ""}
          {/* </div> */}
        </InputLabel>
        <ThemeProvider theme={MuiTheme}>
          <Select
            style={
              disabled
                ? {
                    borderColor: "rgb(202, 209, 215)",
                    backgroundColor: "rgb(248, 249, 255)"
                  }
                : {}
            }
            labelId={inputLabelId}
            id={selectId}
            disabled={disabled}
            data-testid={selectTestId}
            value={selectionValue}
            title={selectionValue?.length > 40 ? selectionValue : ""}
            IconComponent={WrappedIcon}
            onOpen={() => setIsOpen(false)}
            onClose={() => setIsOpen(true)}
            inputProps={{
              "data-testid": valueTestId ?? "selection-value"
            }}
            onChange={selectionOnChange}
            displayEmpty
            className={`${
              inputLabelId === "creditBorrowerDrop"
                ? classes.selectEmptyNot
                : classes.selectEmpty
            } ${menuItemStyles}`}
            classes={{
              outlined: classes.selectClassesOutlined
            }}
            error={!!helperText}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: 0
              },
              transformOrigin: {
                vertical: -8,
                horizontal: "left"
              },
              getContentAnchorEl: null
            }}
          >
            {selectionData.map(item => (
              <MenuItem
                value={item.value}
                key={item.value}
                style={{ fontSize: 12, color: "#32325d", lineHeight: 2 }}
                classes={dropdownStyles}
                className={menuItemStyles}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </ThemeProvider>
        {helperText ? (
          <FormHelperText
            error
            data-testid={helperTextTestId ?? "helperTextTestId"}
          >
            {helperText}
          </FormHelperText>
        ) : null}
      </FormControl>
      {(editedLabel && isLATView) || (editedLabel && enableReason) ? (
        <TextField
          InputProps={{ classes }}
          className={classes.commentBox}
          InputLabelProps={{
            style: {
              position: "relative",
              fontWeight: 600,
              fontSize: 12,
              color: "#32325d",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // border: "1px solid #cad1d7",
              backgroundColor: "white"
            }
          }}
          onBlur={onBlur}
          label={
            <Grid
              container
              item
              xs={12}
              sm={12}
              className={classes.labelContainer}
            >
              <Grid
                item
                xs={12}
                md={12}
                sm={12}
                container
                style={{ display: "block" }}
              >
                {/* <span className={classes.labelInformation}> */}
                <Tooltip
                  title={`${label}`}
                  placement="right"
                  arrow
                  classes={{
                    tooltip: classes.tooltip,
                    arrow: classes.arrow
                  }}
                >
                  <span className={classes.labelInformation}>
                    Reason For Editing {label}
                  </span>
                </Tooltip>
                {/* </span> */}
                {/* {notRequired ? ( */}
                <span className={classes.labelRequiredComments}>
                  <sup>*</sup>
                </span>
                {/* ) : (
                    ""
                  )} */}
              </Grid>
            </Grid>
          }
          style={{
            flex: 1,
            width: "100%",
            marginTop: "20px !important",

            ...style
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
}
